import React from "react";
import ReactDom from "react-dom";
import { createStore, combineReducers } from "redux";
import { Provider } from "react-redux";
import { axiosMM } from "../../shared/axiosCreator";

import PriceCalendar, { reducer } from "./index";
import { LEGACY_API } from "../../shared/constants";
let LEGACY_API_URL = LEGACY_API.replace("-hmg", ""); // Deixei assim por enquanto pra testar, já que o hmg não funciona.

const node = document.getElementById("price-calendar");

const getCityNameByIata = term =>
	axiosMM.get(`${LEGACY_API_URL}/airports/search/${term}`).then(({ data }) => {
		if (!data) return null;
		const item = data.find(item => item.iata == term);
		return item ? item.city : null;
	});

const mountCalendar = (node, store) => {
	if (node && store) {
		const App = () => (
			<Provider store={store}>
				<PriceCalendar />
			</Provider>
		);

		const oldCalendar = document.querySelectorAll(".old-calendar, .newsletter");
		if (oldCalendar) for (const n of oldCalendar) n.remove();

		ReactDom.render(<App />, node);
	}
};

const init = async (node, tripType, activeToggle) => {
	if (!node) return null;
	const track = node.getAttribute("data-track");
	const fixedOrigin = node.getAttribute("data-fixed-origin");
	const [originIata, destinationIata] = track.split("-");
	const [originName, destinationName] = [
		await getCityNameByIata(originIata),
		await getCityNameByIata(destinationIata)
	];

	if (!originIata || !destinationIata) return null;

	let initialState = {
		destination: {
			city: destinationName || destinationIata,
			iata: destinationIata
		},
		origin: {
			city: originName || originIata,
			iata: originIata,
			fixed: fixedOrigin ? true : false
		},
		tripType: tripType,
		tripTypeSwitch: activeToggle ? true : false
	};

	const rootReducer = combineReducers({ priceCalendar: reducer });
	const reduxDevTools =
		window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
	const INITIAL_STATE = { priceCalendar: initialState };
	const store = createStore(rootReducer, INITIAL_STATE, reduxDevTools);
	mountCalendar(node, store);
};

window.initCalendar = (tripType = "OW", activeToggle = true) => {
	init(node, tripType, activeToggle);
};

initCalendar("OW", false);
